import { render, staticRenderFns } from "./MilestoneTemplateEdit.vue?vue&type=template&id=67166532"
import script from "./MilestoneTemplateEdit.vue?vue&type=script&lang=js"
export * from "./MilestoneTemplateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports